import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useState,
} from 'react';

import { stripBaseName } from '@service-initiation/shared-utils-helpers';

import { type Flow, type FlowMetadata } from './types';

export type FlowManagerContextType = {
  flow: Flow;
  metadata: FlowMetadata;
  rootPath: string;
  setMetadata: Dispatch<SetStateAction<FlowMetadata>>;
  state?: unknown;
};

export const FlowManagerContext = createContext<
  FlowManagerContextType | undefined
>(undefined);

export type FlowManagerProviderProps = {
  baseName?: string;
  children: React.ReactNode;
  flow: Flow;
  rootPath: string;
  state?: unknown;
};

export const FlowManagerProvider = ({
  baseName = '/',
  children,
  flow,
  rootPath,
  state,
}: FlowManagerProviderProps) => {
  const [metadata, setMetadata] = useState<FlowMetadata>({
    stepCount: 1,
    visitedPaths: [stripBaseName(baseName, window.location.pathname)],
  });

  return (
    <FlowManagerContext.Provider
      value={{ flow, metadata, rootPath, setMetadata, state }}
    >
      {children}
    </FlowManagerContext.Provider>
  );
};
